import { ProductByURLType } from "../product";
export interface PriceAttribute {
  property: Property;
  attribute: Attribute[];
}

interface Attribute {
  id: number;
  attribute_name: string;
  ProductIdentityId: number
}

interface Property {
  id: number;
  property_name: string;
  property_main: boolean;
  property_price: boolean;
}

export const loadData = (product: ProductByURLType): PriceAttribute[] => {
  const result: PriceAttribute[] = []; // Explicitly type result as PriceAttribute[]

  product.ProductIdentities.forEach((item) => {
    item?.ProdProperties?.forEach((prodProperty) => {
      const propertyId = prodProperty?.Property?.id;
      const existingPropertyIndex = result.findIndex(
        (prop) => prop.property.id === propertyId
      );

      if (existingPropertyIndex === -1) {
        // If the property doesn't exist in result, add it along with its attribute
        result.push({
          property: prodProperty.Property,
          attribute: [
            {
              id: prodProperty.Attribute.id,
              attribute_name: prodProperty.Attribute.attribute_name,
              ProductIdentityId: item.id
            },
          ],
        });
      } else {
        // If the property already exists in result, check if the attribute exists
        const existingAttributeIndex = result[
          existingPropertyIndex
        ].attribute.findIndex((attr) => attr.id === prodProperty.Attribute.id);
        if (existingAttributeIndex === -1) {
          // If the attribute doesn't exist, add it
          result[existingPropertyIndex].attribute.push({
            id: prodProperty.Attribute.id,
            attribute_name: prodProperty.Attribute.attribute_name,
            ProductIdentityId: item.id
          });
        }
      }
    });
  });

  return result;
};
